import Button from '../Button';

interface ShowButtonProps {
	forSettingOLOStore: boolean | undefined;
	oLOEnabled: boolean | undefined | null;
	isDisabled: boolean;
	buttonText: string;
	buttonAction: () => void;
}
export const SelectButton = ({
	forSettingOLOStore,
	oLOEnabled,
	isDisabled,
	buttonText,
	buttonAction
}: ShowButtonProps): JSX.Element | null => {
	return !forSettingOLOStore || (forSettingOLOStore && oLOEnabled) ? (
		<Button
			$buttonSize="small"
			$maxWidth="100px"
			$minWidth="80px"
			disabled={isDisabled}
			onClick={buttonAction}
		>
			{buttonText}
		</Button>
	) : null;
};
